import React from 'react';

import { mobileSupportPageSignal } from 'features/mobile-report/state/mobile-report.signals';
import { Button } from 'ui-components/button/button';
import { ImgWithFallback } from 'features/mobile-report/shared/components/img-with-fallback/img-with-fallback';
import chatIllustration from 'components/assets/Icons/mobile/chat-illustration.webp';
import chatIllustrationFallback from 'components/assets/Icons/mobile/chat-illustration.avif';

import styles from './mobile-support-pages.module.scss';

export const SupportSuccessMobile = () => {
    const handleClose = () => {
        mobileSupportPageSignal.value = undefined;
    };

    return (
        <>
            <div className={styles.messageBody}>
                <ImgWithFallback
                    src={chatIllustration}
                    fallbackSrc={chatIllustrationFallback}
                    alt="error"
                    className={styles.messageImage}
                />
                <h1 className={styles.messageTitle}>{'Thanks,\n We Received Your Ticket!'}</h1>
                <p className={styles.messageDescription}>
                    {
                        'A support ticket has been opened.\n One of our team members will reach out to you shortly.'
                    }
                </p>
            </div>
            <Button
                className={styles.mainButton}
                type="primary"
                onClick={handleClose}
                data-testid="support-success-mobile-close"
            >
                Close
            </Button>
        </>
    );
};
